<h2 mat-dialog-title>{{ data?.title }}</h2>

<mat-dialog-content>
  <div [innerHTML]="surveyMessage"></div>

  @if (surveyForm.get('reason')?.invalid && surveyForm.get('reason')?.touched) {
    <div class="error-message">
      Please select a reason before disconnecting
    </div>
  }
  <form [formGroup]="surveyForm" class="survey-form">
    <mat-radio-group formControlName="reason" class="reason-radio-group" required>
      @for (reason of disconnectReasons; track reason) {
        <mat-radio-button
          [value]="reason.value"
          class="reason-option">
          {{ reason.label }}
        </mat-radio-button>
      }
    </mat-radio-group>

    <div class="comments-field-wrapper">
      <span class="char-counter">{{ surveyForm.get('otherComments')?.value?.length || 0 }}/500</span>
      <mat-form-field appearance="outline" class="comments-field">
        <mat-label>Any other comments? (Optional)</mat-label>
        <textarea
          matInput
          formControlName="otherComments"
          rows="3"
          maxlength="501"
          class="disconnection-comment"
          placeholder="Enter your comments here..."></textarea>
      </mat-form-field>
    </div>
    @if (surveyForm.get('otherComments')?.hasError('maxlength')) {
      <div class="error-message">
        Comment cannot exceed 500 characters
      </div>
    }

    <div class="confirmation-message">
      Are you sure you want to disconnect your account?
    </div>
  </form>
  <mat-dialog-actions align="end">
    <button
      mat-button
      class="btn btn-pink"
      (click)="cancel()"
      [disabled]="isDisconnecting"
      id="dialog-cancel-button">
      {{ data?.cancelBtnText || 'Cancel' }}
    </button>
    <button
      mat-button
      class="btn btn-pink"
      (click)="confirm()"
      [disabled]="isDisconnecting"
      id="dialog-confirm-button">
      @if (!isDisconnecting) {
        <span>{{ data?.confirmBtnText || 'Confirm' }}</span>
      }
      @if (isDisconnecting) {
        <span>Unlinking...</span>
      }
    </button>
  </mat-dialog-actions>

</mat-dialog-content>

